module.exports = __webpack_public_path__ + "img/Pr18.04152aa6.png";